import React, { useEffect, useState } from "react";
import patient from "../../assets/img/patient.jpg";
import rightArrow from "../../assets/img/arrow-right.svg";
import upload_icon from "../../assets/img/upload_icoon.svg";
import tooltip_info_icon from "../../assets/img/tooltip_info_icon.svg"
// import { toast, ToastContainer } from "react-toastify"
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { patientInformation, patientManage } from "../../redux/action";
import { useNavigate } from "react-router";
import { showToast, ToastContainer } from "../../util/toastHelper";
import { CallWithAuth } from "../../action/apiActions";
import { PATIENT_INFORMATION_API_URL, UPLOAD_CLICNICAL_INTAKE_DOC } from "../../action/apiPath";
import { createShortNameFile, errorMessageCreate } from "../../util/custom";
import { PATIENT_INFORMATION } from "../../redux/constant";

const ManagePatientPage = () => {
  const selector = useSelector((state) => state.GET_MANAGE_PATIENT_REDUCER)
  const navigate = useNavigate()
  const [patientDetail, setPatientDetail] = useState({
    full_name: null,
    dob: null,
    email: "",
    phone: "",
    patient_face_image_consent: false,
  });
  const [PatientFaceImageFromdragging, setDraggingPatientFaceImageFrom] = useState(false);
  const [dr_uploaded_face_image, SetDrUploadedFaceImage] = useState('');

  const [isFaceImageLoading, setIsFaceImageLoading] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);




  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setPatientDetail({ ...patientDetail, [name]: value });
  };


  const handleFileChange = (e) => {
    console.log(e)
    const { name, files } = e.target;
    let validFiles = [];

    if (name === "reports") {

      validFiles = [...files].filter((file) =>
        [".pdf", ".doc", "docx"].includes(file.name.slice(-4).toLowerCase())
      );

      if (validFiles.length !== files.length) {
        showToast("warn", 'Only .docs and .pdf formats are supported for reports.');
        return;
      }
      setPatientDetail({ ...patientDetail, reports: validFiles.slice(0, 5) });

    } else if (name === "audio") {
      const file = files[0];
      if (file && ![".mp3", ".wav", ".m4a"].includes(file.name.slice(-4).toLowerCase())) {
        showToast("warn", 'Only MP3, .WAV, and .M4A formats are supported for audio.');
        return;
      }
      console.log("Valid audio file: ", file);

      setPatientDetail({ ...patientDetail, audio: file });
    }
  };


  const dispatch = useDispatch()

  const handleSuccessCreatePatent = (response) => {
    // console.log("=============>===>", res)

    if (response.res.status == 200 || response.res.status == 201) {
      // Dispatch the success action after the API call succeeds
      console.log({ response })
      navigate('/patient-information')
    }
  }

  const handleSubmit = async () => {
    // console.log("Submitting patient details:", patientDetail);
    if (!patientDetail.full_name) {
      showToast("error", "Name is required.");
      return;
    }

    if (!patientDetail.email) {
      showToast("error", "Email is required.");
      return;
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(patientDetail.email)) {
      showToast("error", "Invalid email format.");
      return;
    }

    if (!patientDetail.phone) {
      showToast("error", "Phone number is required.");
      return;
    }
    if (patientDetail.phone.trim().length < 10 || patientDetail.phone.trim().length > 15) {
      showToast("error", "Phone number must be between 10 - 15 digits");
      return;
    }

    if (!patientDetail.dob) {
      showToast("error", "Date of Birth is required.");
      return;
    } else if (patientDetail.dob == 'Invalid date') {
      showToast("error", "Date of Birth is invalid.");
      return;
    } else if (moment(patientDetail.dob) < moment('1950-01-01T00:00:00.000Z')) {
      showToast("error", "Date of Birth is invalid.");
      return;
    }

    if (patientDetail.patient_face_image_consent) {
      if (dr_uploaded_face_image == '') {
        showToast("error", "Please upload the patient's facial image.");
        return;
      } else {
        patientDetail.dr_uploaded_face_image = dr_uploaded_face_image
      }
    }
    
    try {
      setIsSubmit(true);
      let response = await CallWithAuth("POST", PATIENT_INFORMATION_API_URL, patientDetail);
      // console.log("response==>", response);

      let message = errorMessageCreate(response?.res?.data?.message);
      if (response?.res?.data?.statusCode === 201) {
        showToast("success", message);
        setTimeout(() => {
          navigate('/patient-information');
          setIsSubmit(false);

        }, 1000);

      } else {
        let message = errorMessageCreate(response?.res?.data?.message);
        showToast("error", message);
        setIsSubmit(false);
      }
    } catch (err) {
      console.log(err);
      setIsSubmit(false);
    }

    // dispatch(patientManage({ ...patientDetail, cb: handleSuccessCreatePatent }))

    // Further submit logic here
  };

  const handleManagePatientEffect = () => {
    if (selector.error == null) {
      if (selector.data != null) {
        dispatch(patientInformation())
        showToast("success", selector.message);
      }
    } else {
      showToast("error", selector.error);
    }
  }

  /*useEffect(() => {
    handleManagePatientEffect()
  }, [selector])*/
  const handleDropPatientFaceImageFrom = async (e) => {
    e.preventDefault();
    try {
      setIsFaceImageLoading(true);
      const files = e.dataTransfer.files;
      const file = files[0];

      const formdata = new FormData();
      formdata.append("file", file);
      const body = formdata;
      const response = await CallWithAuth("POST", UPLOAD_CLICNICAL_INTAKE_DOC, body);
      let message = errorMessageCreate(response?.res?.data?.message);

      if (response?.res?.data?.statusCode === 200) {
        // setDigitalSignature(response.res.data.data.file_url);
        showToast("success", "Patient's facial image uploaded successfully.");
        SetDrUploadedFaceImage(response?.res?.data?.data?.file_url)
      } else {
        showToast("error", message);
      }
    } catch (err) {

    }
    setIsFaceImageLoading(false);

    // setPatientFaceImageAudio(file);
  };
  const handleChangePatientFaceImageFile = async (e) => {
    setIsFaceImageLoading(true);

    try {
      const { files } = e.target;
      const file = files[0];
      const formdata = new FormData();
      formdata.append("file", file);
      const body = formdata;
      const response = await CallWithAuth("POST", UPLOAD_CLICNICAL_INTAKE_DOC, body);
      let message = errorMessageCreate(response?.res?.data?.message);

      if (response?.res?.data?.statusCode === 200) {
        // setDigitalSignature(response.res.data.data.file_url);
        showToast("success", "Patient's facial image uploaded successfully.");
        SetDrUploadedFaceImage(response?.res?.data?.data?.file_url);
      } else {
        showToast("error", message);
      }
    } catch (err) { }
    setIsFaceImageLoading(false);

  }
  const handleDragOverPatientFaceImageFrom = (e) => {
    e.preventDefault();
    setDraggingPatientFaceImageFrom(true);
  };

  const handleDragLeavePatientFaceImageFrom = () => {
    setDraggingPatientFaceImageFrom(false);
  };
  return (
    <div className="create_account_block">
      <div className="site_container">
        <div className="create_account_form">
          <div className="heading_block">
            <span className="tag">Add Patient</span>
            <h1>Manage Patient File</h1>
            <p>Manage each patient’s file efficiently</p>
          </div>


          <div className="field_block">
            <label for="">Full name <span className="text-danger">*</span></label>
            <input
              type="text"
              name="full_name"
              className="text_field"
              placeholder="Enter Full Name"
              value={patientDetail.full_name}
              onChange={handleInputChange}
            />

          </div>
          <div className="field_block">
            <label for="">Email <span className="text-danger">*</span></label>
            <input
              placeholder="Enter email."
              type="text"
              name="email"
              className="text_field"
              value={patientDetail.email}
              onChange={handleInputChange}
            />
          </div>
          <div className="field_block">
            <label for="">Phone Number <span className="text-danger">*</span></label>
            <input
              placeholder="Enter phone number."
              type="number"
              name="phone"
              className="text_field no-spinners"
              value={patientDetail.phone}
              onChange={handleInputChange}
            />

          </div>
          <div className="field_block">
            <label for="">Date of Birth <span className="text-danger">*</span></label>
            <input type="date"
              name="dob"
              className="text_field"
              value={moment(patientDetail.dob).format("YYYY-MM-DD")}
              onChange={(e) =>
                setPatientDetail({
                  ...patientDetail,
                  dob: moment(e.target.value).toISOString(),
                })
              }
              max={moment().format("YYYY-MM-DD")}
            />

          </div>
          <div className="field_block">
            <div className="d-flex items-center gap-2"><input
              type="checkbox"
              id="consent"
              name="consent"
              checked={patientDetail.patient_face_image_consent}
              onChange={(e) =>
                setPatientDetail({ ...patientDetail, patient_face_image_consent: e.target.checked })
              }
              
            />
              <label htmlFor="consent" className=" m-0">Do you have the patient's consent to upload the photo?</label>

            </div>
            </div>

            {patientDetail.patient_face_image_consent && (
              <div className="row">
                <div
                  className="field_block col-md-6"
                  onDrop={(e) => handleDropPatientFaceImageFrom(e)}
                  onDragOver={handleDragOverPatientFaceImageFrom}
                  onDragLeave={handleDragLeavePatientFaceImageFrom}
                >
                  <div className="upload_field">
                    <div className="title">
                      <label>Please upload the patient's facial image</label>{" "}
                    </div>

                    <div className="upload_ui">
                      <label className="upload_ui_label">
                        <input
                          type="file"
                          name="audio"
                          accept=".png, .jpg, .jpeg"  // Only allow image files
                          onChange={handleChangePatientFaceImageFile}
                          style={{ display: "none" }} // Hide input element
                        />
                        <div className="ui_inner">
                          <img src={upload_icon} alt="Upload" />
                          <h5>Upload</h5>
                          <p>
                            <span>Browse</span> to upload the file
                          </p>
                        </div>
                      </label>
                    </div>
                    {dr_uploaded_face_image && dr_uploaded_face_image != '' && (
                      <>
                        <div className="record_seesion_info">
                          <p className="sm_txt">
                            <strong>
                              {createShortNameFile(
                                dr_uploaded_face_image
                              )}
                            </strong>
                          </p>
                          <a
                            href={`${dr_uploaded_face_image}`} // Full URL for S3 file
                            target="_blank" // Opens link in a new tab
                            rel="noopener noreferrer" // Security best practice
                            className="edit"
                          >
                            <i className="fa-solid fa-eye"></i>
                          </a>
                        </div>
                      </>
                    )}

                  </div>
                </div>
              </div>
            )}

            <div className="btn_row">
              <button disabled={isFaceImageLoading || isSubmit} onClick={handleSubmit} className="solid_cta cta_primary cta_with_icon">
                <span>Submit </span> {""} 
                {isSubmit && (
                  <>
                    {""}
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  </>
                )}
              </button>
              <ToastContainer />

            </div>
          </div>
        </div>
      </div>
      );
};

      export default ManagePatientPage;
